import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

async function requestPasswordReset(payload) {
  const response = await apiClient.post(
    "/api/v1/auth/users/reset_password/",
    payload
  );
  return response.data;
}

function useForgotPassword() {
  return useMutation({ mutationFn: requestPasswordReset });
}

export { useForgotPassword };
